__webpack_require__.p = "/heat-rapid-triples/";